<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<button type="button" class="btn btn-warning btn-ico" (click)="open()">
  <i class="fal fa-history"></i>
</button>
